import { useLingui } from '@lingui/react/macro';
import type { FC } from 'react';
import { useHasAccessToken } from '@/auth/api';
import { Link } from '@/base/router';
import { Button } from '@/shared/Button';
import { cn } from '@/shared/react';
import { HeroBackground } from './HeroBackground';
import { HeroTexts } from './HeroTexts';

export const Hero: FC<{ className?: string }> = ({ className }) => {
  const hasAccessToken = useHasAccessToken();
  const { t } = useLingui();

  return (
    <section
      id="hero"
      className={cn('relative desktop:h-[576px] h-[350px]', className)}
    >
      <div className="px-3 relative max-w-desktop mx-auto h-full overflow-hidden flex flex-col justify-between desktop:bg-transparent bg-gradient-to-b from-brand-400/20 dark:from-brand-400/40 to-transparent desktop:from-transparent desktop:to-transparent desktop:border-none py-12 desktop:py-0">
        <HeroBackground className="absolute size-full inset-0 desktop:block hidden" />
        <HeroTexts />

        <div className="flex flex-col items-center gap-5">
          <Link
            workspace="app"
            to={hasAccessToken ? '/dashboard' : '/auth'}
            className="block desktop:max-w-2xs w-full"
          >
            <Button size={12} variant="primary" block className="w-full">
              {hasAccessToken ? t`Enter Dashboard` : t`Get Started`}
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};
